import { Contractor } from "@/api/williams/contractors";
import { Project } from "@/api/williams/project";
import { ScopeOfWork, ScopeOfWorkStatus } from "@/api/williams/scopesOfWork";
import { ScopeOfWorkForm } from "./form";
import { useDefaultScope } from "./hooks";
import { useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";

export type LocationState = {
  state: {
    project?: Project;
    contractor?: Contractor;
  };
};

export function CreateScope() {
  const defaults = useDefaultScope();
  const location = useLocation();

  const { state } = location as LocationState;

  if (defaults.isLoading) {
    return <p>Loading...</p>;
  }

  const defaultValues: ScopeOfWork = {
    id: uuid(),
    number: defaults.data?.number ?? "",
    description: "",
    locked: false,
    template: false,
    owner: defaults.data?.owner,
    reportDate: new Date().toISOString().substring(0, 10),
    status: ScopeOfWorkStatus.New,
    welders: [],
    inServiceWelding: false,
    allowQualificationsByNde: false,
    applyRepairWelderQualReqs: false,
    newYorkProject: false,
    project: state?.project,
    contractorId: state?.contractor?.id,
  };

  return <ScopeOfWorkForm data={defaultValues} />;
}
